<div class="flex ml-1 mr-1" *ngIf="count > 0 || showIfZero; else zero">
  <span style="width: 10px; height: 20px" [class]="'rounded-tl-full rounded-bl-full ' + bgClass"> </span>
  <span
    style="height: 20px"
    [class]="'text-white text-sm flex justify-center leading-none items-center ' + bgClass"
    *ngIf="currency === true; else notCurrency"
  >
    <span>{{ count | currencyInPennies }}</span>
  </span>
  <ng-template #notCurrency>
    <span style="height: 20px" [class]="'text-white text-sm flex justify-center leading-none items-center ' + bgClass">
      <span>{{ prettyPrintMinutes ? prettyPrintedMinutes : count }}</span>
    </span>
  </ng-template>
  <span style="width: 10px; height: 20px" [class]="'rounded-tr-full rounded-br-full ' + bgClass"> </span>
</div>
<ng-template #zero> </ng-template>
